import { Session } from '../../../domain/entities';
import { ISessionRepository } from '../../repositories/ISessionRepository';
import { sessionApi } from './sessionApi';

export class SessionRepositoryApi implements ISessionRepository {
  // Получение сессий
  async getAllSessionsForUser(userId: number): Promise<Session[]> {
    return await sessionApi.getAllSessionsForUser(userId);
  }

  async getOpenSessionsForUser(userId: number): Promise<Session[]> {
    return await sessionApi.getOpenSessionsForUser(userId);
  }

  async getClosedSessionsForUser(userId: number): Promise<Session[]> {
    return await sessionApi.getClosedSessionsForUser(userId);
  }

  async getSessionById(sessionId: number): Promise<Session | null> {
    return await sessionApi.getSessionById(sessionId);
  }

  // Управление сессиями
  async createSession(session: Omit<Session, 'id'>): Promise<Session> {
    return await sessionApi.createSession({
      userId: session.userId,
      siteId: session.siteId,
      typeOfWorkId: session.typeOfWorkId,
      startTime: session.startTime
    });
  }

  async updateSession(sessionId: number, updates: Partial<Session>): Promise<Session> {
    return await sessionApi.updateSession(sessionId, updates);
  }

  async closeSession(sessionId: number, endTime: string): Promise<Session> {
    return await sessionApi.closeSession(sessionId, endTime);
  }

  async deleteSession(sessionId: number): Promise<boolean> {
    return await sessionApi.deleteSession(sessionId);
  }

  // Статистика
  async getSessionStatistics(userId: number, period?: string): Promise<any> {
    return await sessionApi.getSessionStatistics(userId, period);
  }
}
